<!-- Heatmaps in the heatmaps folder should be removed and corresponding
Mapbox Studio heatmap sources should be displayed using only this component. -->

<template>
  <GeojsonLayer
    v-if="visible"
    :before="before"
    :layer="layer"
    :source="data"
    :sourceId="sourceId"
  />
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import GeojsonLayer from '@/components/map/mapbox-layers/GeojsonLayer.vue'
import axios from 'axios'
import { MAPVIEW_PREFIX, PLANVIEW_PREFIX } from '@/store/module-prefixes'
export default {
  name: 'LayerHeatmapStatic',
  components: {
    GeojsonLayer
  },
  props: {
    before: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      layerId: 'layer-heatmap-static',
      sourceId: 'source-heatmap-static',
      data: {
        type: 'geojson',
        data: {
          id: 'source-heatmap-static',
          type: 'FeatureCollection',
          features: []
        }
      },
      paint: {
        'heatmap-weight': [
          'interpolate',
          ['linear'],
          ['zoom'],
          15,
          [
            'match',
            ['get', 'Signal_Lev'],
            [20, 21, 22, 23, 24, 25, 26, 27, 28, 29],
            0,
            [30, 31, 32, 33, 34, 35, 36, 37, 38, 39],
            0,
            [40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
            0,
            [50, 51, 52, 53, 54, 55, 56, 57, 58, 59],
            0,
            [60, 61, 62, 63, 64, 65, 66, 67, 68, 69],
            0,
            [70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
            0,
            [80, 81, 82, 83, 84, 85, 86, 87, 88, 89],
            0,
            [90, 91, 92, 93, 94],
            0,
            0
          ],
          17,
          [
            'match',
            ['get', 'Signal_Lev'],
            [20, 21, 22, 23, 24, 25, 26, 27, 28, 29],
            0.2,
            [30, 31, 32, 33, 34, 35, 36, 37, 38, 39],
            0.3,
            [40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
            0.4,
            [50, 51, 52, 53, 54, 55, 56, 57, 58, 59],
            0.5,
            [60, 61, 62, 63, 64, 65, 66, 67, 68, 69],
            0.6,
            [70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
            0.7,
            [80, 81, 82, 83, 84, 85, 86, 87, 88, 89],
            0.8,
            [90, 91, 92, 93, 94],
            0.9,
            0.2
          ],
          22.1,
          [
            'match',
            ['get', 'Signal_Lev'],
            [20, 21, 22, 23, 24, 25, 26, 27, 28, 29],
            3,
            [30, 31, 32, 33, 34, 35, 36, 37, 38, 39],
            4,
            [40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
            5,
            [50, 51, 52, 53, 54, 55, 56, 57, 58, 59],
            6,
            [60, 61, 62, 63, 64, 65, 66, 67, 68, 69],
            7,
            [70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
            8,
            [80, 81, 82, 83, 84, 85, 86, 87, 88, 89],
            9,
            [90, 91, 92, 93, 94],
            10,
            2
          ]
        ],
        'heatmap-intensity': 0.025,
        'heatmap-color': [
          'interpolate',
          ['linear'],
          ['heatmap-density'],
          0,
          'rgba(0, 0, 255, 0)',
          0.1,
          'hsl(225, 61%, 58%)',
          0.4,
          'hsl(180, 78%, 49%)',
          0.6,
          'hsl(120, 83%, 51%)',
          0.8,
          'hsl(60, 84%, 49%)',
          1,
          'hsl(0, 91%, 48%)'
        ],
        'heatmap-radius': ['interpolate', ['linear'], ['zoom'], 17, 1, 22, 80],
        'heatmap-opacity': 0.6
      },
      intervalid1: null,
      changes: null
    }
  },
  computed: {
    ...mapState(PLANVIEW_PREFIX, {
      isSensordataShowing: (state) => state.isSensordataShowing,
      currentSensordataType: (state) => state.currentSensordataType
    }),
    ...mapState(MAPVIEW_PREFIX, {
      selectedBuilding: (state) => state.selectedBuilding
    }),
    ...mapGetters({
      isPlanviewShowing: 'isPlanviewShowing',
      selectedLevelNumber: 'selectedLevelNumber'
    }),
    layer() {
      return {
        id: this.layerId,
        source: this.sourceId,
        type: 'heatmap',
        minzoom: 16,
        maxzoom: 24,
        paint: this.paint
      }
    },
    visible() {
      return (
        this.isSensordataShowing &&
        this.isPlanviewShowing &&
        this.currentSensordataType === 'wifi' &&
        this.selectedBuilding.id === '834089140215631872' // AWL
      )
    }
  },
  watch: {
    selectedLevelNumber() {
      this.getHeatmap()
    }
  },
  beforeUnmount() {
    clearInterval(this.intervalid1)
  },
  created() {
    this.getHeatmap()
  },
  methods: {
    onRandomizeUpdate() {
      this.intervalid1 = setInterval(() => {
        const randomIndices = []
        for (let i = 0; i < 3000; i++) {
          randomIndices.push(Math.floor(Math.random() * this.data.data.features.length))
        }
        randomIndices.forEach((el) => {
          if (!this.data.data.features[el]) return
          let newSignalLevel =
            this.data.data.features[el].properties.Signal_Lev * (Math.random() + 0.6)
          if (newSignalLevel > 94) newSignalLevel = 94
          else if (newSignalLevel < 20) newSignalLevel = 20
          this.data.data.features[el].properties.Signal_Lev = newSignalLevel
        })
      }, 1000)
    },
    getHeatmap: async function () {
      this.data.data.features = []
      let maxVal = 0
      let minVal = 100
      clearInterval(this.intervalid1)
      let url = ''
      if (['0', '7'].includes(this.selectedLevelNumber))
        url = 'https://heatmapdatasets.blob.core.windows.net/datasets/awl_7.geojson'
      else if (this.selectedLevelNumber === '6')
        url = 'https://heatmapdatasets.blob.core.windows.net/datasets/awl_6.geojson'
      else if (['1', '3', '4'].includes(this.selectedLevelNumber))
        url = 'https://heatmapdatasets.blob.core.windows.net/datasets/awl_4.geojson'
      else if (['2', '5'].includes(this.selectedLevelNumber))
        url = 'https://heatmapdatasets.blob.core.windows.net/datasets/awl_2.geojson'
      else return
      const res = await axios.get(url)
      const tempData = res.data.features
      tempData.forEach((el) => {
        const signalLev = parseInt(el.properties.Signal_Lev)
        if (signalLev > maxVal) maxVal = signalLev
        else if (signalLev < minVal) minVal = signalLev
        el.properties.Signal_Lev = signalLev
      })
      this.data.data.features.push(...tempData)
      this.onRandomizeUpdate()
    }
  }
}
</script>
